<template>
  <v-alert
    :type="type"
    :icon="icon"
    :color="color"
    :dismissible="dismissible"
    text
    outlined
    dense
    border="left"
  >
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  name: 'AppAlert',

  props: {
    icon: {
      type: String,
      required: false,
      default: 'info',
    },
    type: {
      type: String,
      required: false,
      default: 'info',
    },
    color: {
      type: String,
      required: false,
      default: undefined,
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: false,
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
